import React, { useState, useEffect } from 'react';



import HeroSection from './components/HeroSection';
import SignatureDishes from './components/SignatureDishes';
import LiveKitchen from './components/LiveKitchen';
import BrandPillars from './components/BrandPillars';
import CustomerTestimonials from './components/CustomerTestimonials';
import OrderingWidget from './components/OrderingWidget';
import CommunitySection from './components/CommunitySection';
import Footer from './components/Footer';

const Homepage = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-4 border-primary border-t-transparent mx-auto mb-4"></div>
          <p className="font-body text-text-secondary">Preparing your Mediterranean experience...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      {/* Hero Section */}
      <HeroSection />
      
      {/* Signature Dishes Carousel */}
      <SignatureDishes />
      
      {/* Live Kitchen Section */}
      <LiveKitchen />
      
      {/* Brand Pillars */}
      <BrandPillars />
      
      {/* Customer Testimonials */}
      <CustomerTestimonials />
      
      {/* Ordering Widget */}
      <OrderingWidget />
      
      {/* Community Section */}
      <CommunitySection />
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Homepage;